var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "my_account",
    "data-name": "my account",
    transform: "translate(-266.016 -42.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account_2",
    "data-name": "Account 2",
    transform: "translate(265.406 41.406)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_846",
    "data-name": "Rectangle 846",
    width: 22,
    height: 22,
    transform: "translate(0.61 0.61)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-person",
    "data-name": "Icon material-person",
    d: "M14.333,14.333a4.166,4.166,0,1,0-4.166-4.166A4.165,4.165,0,0,0,14.333,14.333Zm0,2.083c-2.781,0-8.333,1.4-8.333,4.166v2.083H22.665V20.582C22.665,17.811,17.114,16.416,14.333,16.416Z",
    transform: "translate(-2.89 -1.89)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.f9153de92808feef761515b904d51755.svg";
export { ForwardRef as ReactComponent };